import { inject, Component } from "@angular/core";
import { AppSettings, APP_SETTINGS } from "app/app.settings";


@Component({
    selector: "footer[app-footer]",
    templateUrl: "./footer.component.html"
})
export class FooterComponent {
    env = inject<AppSettings>(APP_SETTINGS);

    version = `${this.env.info.product}\nVersion: ${this.env.info.version}\nBuild version: ${this.env.info.fileVersion}\n${this.env.info.copyright}`;
}
